export const legacyPropMap = {
    browsers: "test_profile_name",
    browserTypes: "browser_types",
    browserVersions: "browser_versions",
    connectionTypes: "con",
    countrySubdivisions: "country_subdivision",
    customerData: "customer_data",
    dateRange: "start_time_seconds_ago",
    deliveryTypes: "delivery_types",
    deviceTypes: "device_types",
    errorMessage: "msg",
    hostnames: "hostname",
    inpPhases: "inp_phases",
    metricBounds: "metric_bounds",
    navigationTypes: "navigation_types",
    operatingSystems: "operating_systems",
    pageAttributes: "page_attributes",
    pageLabels: "label",
    pathnames: "pathname",
    regions: "region",
    sessionEvents: "session_events",
    siteIds: "site_ids",
    snapshotIds: "snapshot_ids",
    userHappinessScores: "user_happiness_scores",
};
/**
 * Transform a DataRequest object into a FavoriteDataRequest
 */
export default function requestObjectTransformer(request) {
    const favoriteDataRequest = {
        chart_id: request.chartId,
        chart_type: request.queryType,
        metric: request.metrics,
    };
    if (request.aggregationType) {
        favoriteDataRequest.stat = request.aggregationType;
    }
    if ("correlationAggregationType" in request && request.correlationAggregationType) {
        favoriteDataRequest.correlation_stat = request.correlationAggregationType;
    }
    if ("correlationMetrics" in request && request.correlationMetrics) {
        favoriteDataRequest.correlation_metrics = request.correlationMetrics;
    }
    if ("budget" in request && request.budget) {
        favoriteDataRequest.budget = request.budget;
    }
    if (request.filters) {
        const filters = request.filters;
        Object.entries(legacyPropMap).forEach(([filterKey, requestKey]) => {
            const filterValue = filters[filterKey];
            if (filterValue !== undefined && filterKey !== "dateRange") {
                favoriteDataRequest[requestKey] = filterValue;
            }
        });
        if (filters.dateRange) {
            if ("secondsAgo" in filters.dateRange) {
                favoriteDataRequest.start_time_seconds_ago = filters.dateRange.secondsAgo;
            }
            else {
                favoriteDataRequest.start_time = filters.dateRange.startDate;
                favoriteDataRequest.end_time = filters.dateRange.endDate;
            }
        }
    }
    if (request.compareFilters) {
        const compareFilters = request.compareFilters;
        if (compareFilters.dateRange) {
            if ("secondsAgo" in compareFilters.dateRange) {
                favoriteDataRequest.compare_start_time_seconds_ago = compareFilters.dateRange.secondsAgo;
            }
            else {
                favoriteDataRequest.compare_start_time = compareFilters.dateRange.startDate;
                favoriteDataRequest.compare_end_time = compareFilters.dateRange.endDate;
            }
        }
    }
    if ("options" in request && request.options) {
        const options = request.options;
        if ("comparePreviousDate" in options) {
            favoriteDataRequest.compare = options.comparePreviousDate;
        }
        if ("convertCountryCodes" in options) {
            favoriteDataRequest.convert_country_codes = options.convertCountryCodes;
        }
        if ("listFilter" in options) {
            favoriteDataRequest.listfilter = options.listFilter;
        }
        if ("maxListItems" in options) {
            favoriteDataRequest.max_items = options.maxListItems;
        }
        if ("bucketSize" in options) {
            favoriteDataRequest.bucket_size = options.bucketSize;
        }
        if ("queryDialect" in options) {
            favoriteDataRequest.dialect = options.queryDialect;
        }
    }
    return favoriteDataRequest;
}
